import React, {useState, useEffect} from 'react';
import {Link} from 'react-router';
import statusConfig from '../../statics/OrderStatus';
import GetPike from '../../components/Private/GetPike';
import Timer from '../../components/Private/Timer';

const resolveTargetTime = (order) => {
    if (order.get_ready_time && order.get_ready_time !== 'now') {
        return order.get_ready_time;
    }

    if (order.time && order.time !== 'now') {
        return order.time;
    }

    return null;
};

const calculateTimeLeft = (order) => {
    const targetTime = resolveTargetTime(order);
    if (!targetTime || !order.date) return 0;

    const now = new Date();
    const today =
        now.getFullYear() +
        '/' +
        String(now.getMonth() + 1).padStart(2, '0') +
        '/' +
        String(now.getDate()).padStart(2, '0');

    if (order.date !== today) {
        return 0;
    }

    const [readyHour, readyMinute] = targetTime.split(':').map(Number);
    const readyTime = new Date();
    readyTime.setHours(readyHour, readyMinute, 0, 0);

    const diffSeconds = Math.floor((readyTime - now) / 1000);
    return diffSeconds > 0 ? diffSeconds : 0;
};

const TIMED_ORDER_STATUSES = ['pending', 'processing', 'completed'];

const OrderCard = ({order, refetch}) => {
    const [initialTime, setInitialTime] = useState(0);
    const currentStatus = statusConfig[order.status] || statusConfig.processing;
    const statusKey = statusConfig[order.status] ? order.status : 'processing';
    const isTimedOrder = Boolean(order.time && order.time !== 'now');

    useEffect(() => {
        if (isTimedOrder) {
            setInitialTime(calculateTimeLeft(order));
            return;
        }

        setInitialTime(0);
    }, [isTimedOrder, order.status, order.get_ready_time, order.time, order.date]);

    const formatPrice = (price) =>
        `${Number(price || 0).toLocaleString('fa-IR')} تومان`;

    const showTimer =
        isTimedOrder &&
        initialTime > 0 &&
        TIMED_ORDER_STATUSES.includes(order.status);

    const showActions =
        order.status === 'processing' ||
        (order.status === 'completed' && order.sending_method === 'pike');

    return (
        <article className={`rest-orders-card rest-orders-card--${statusKey}`}>
            <div className="rest-orders-card__accent" aria-hidden="true"/>

            <div className="rest-orders-card__header">
                <Link to={`/orders/${order.id}`} className="rest-orders-card__customer">
                    <span className="rest-orders-card__customer-name">{order.full_name}</span>
                    <span className="rest-orders-card__customer-hint">مشاهده جزئیات</span>
                </Link>
                <div className="rest-orders-card__header-badges">
                    {isTimedOrder && (
                        <span className="rest-orders-card__timed-badge" title="سفارش زمان‌دار">
                            زمان‌دار
                        </span>
                    )}
                    <span className="rest-orders-card__status">{currentStatus.label}</span>
                </div>
            </div>

            <div className="rest-orders-card__meta">
                <div className="rest-orders-card__meta-item">
                    <span className="rest-orders-card__meta-label">شماره سفارش</span>
                    <span className="rest-orders-card__meta-value">#{order.id}</span>
                </div>
                <div className="rest-orders-card__meta-item">
                    <span className="rest-orders-card__meta-label">زمان ثبت</span>
                    <span className="rest-orders-card__meta-value">{order.created}</span>
                </div>
                <div className="rest-orders-card__meta-item rest-orders-card__meta-item--price">
                    <span className="rest-orders-card__meta-label">مبلغ</span>
                    <span className="rest-orders-card__meta-value rest-orders-card__price">
                        {formatPrice(order.total_amount)}
                    </span>
                </div>
                <div className="rest-orders-card__meta-item">
                    <span className="rest-orders-card__meta-label">پرداخت</span>
                    <span
                        className={`rest-orders-card__meta-value ${
                            order.payment_method === 'online'
                                ? 'rest-orders-card__tag--online'
                                : 'rest-orders-card__tag--cash'
                        }`}
                    >
                        {order.payment_method === 'online' ? 'آنلاین' : 'در محل'}
                    </span>
                </div>
                <div className="rest-orders-card__meta-item">
                    <span className="rest-orders-card__meta-label">ارسال</span>
                    <span className="rest-orders-card__meta-value">
                        {order.sending_method === 'in_person' ? 'حضوری' : 'پیک'}
                    </span>
                </div>
            </div>

            {(showTimer || showActions) && (
                <div className="rest-orders-card__footer">
                    {showTimer && (
                        <div className="rest-orders-card__timer">
                            <Timer initialSeconds={initialTime} onComplete={() => refetch()}/>
                        </div>
                    )}

                    {showActions && (
                        <div className="rest-orders-card__actions">
                            <GetPike
                                isPike={order.sending_method === 'pike'}
                                orderStatus={order.status}
                                refetch={refetch}
                                id={order.id}
                                buttonColor={
                                    order.status === 'delivery'
                                        ? (statusConfig.delivery || statusConfig.processing).buttonColor
                                        : currentStatus.buttonColor
                                }
                            />
                        </div>
                    )}
                </div>
            )}
        </article>
    );
};

export default OrderCard;
